import { PhysioLayout } from "@/components/layout/physio-layout";
import { CpdModuleReaderContent } from "@/components/cpd/cpd-module-reader";

export default function PhysioLearnModule() {
  return (
    <PhysioLayout title="CPD Learning Hub">
      <CpdModuleReaderContent listPath="/physio/learn" />
    </PhysioLayout>
  );
}
